module.exports = __webpack_public_path__ + "static/media/sensor.720eb00f.png";